import { useState, type FC } from 'react';
import { useIntl } from 'react-intl';

import { ContentSwitcher } from '@xing-com/content-switcher';
import { ContentArticleStatus } from '@xing-com/crate-common-graphql-types';

import { useArticlesModuleContext } from '../../hooks/use-articles-module-context/use-articles-module-context';

type FilterBarProps = {
  defaultActiveItemIndex?: number;
  className?: string;
};
export const FilterBar: FC<FilterBarProps> = ({
  defaultActiveItemIndex = 0,
  className,
}) => {
  const { metadata, updateFilter } = useArticlesModuleContext();
  const { $t } = useIntl();

  const allAmount = metadata?.allAmount;
  const publishedAmount = metadata?.publishedArticlesCount;
  const scheduledAmount = metadata?.scheduledArticlesCount;
  const draftsAmount = metadata?.draftArticlesCount;
  const hiddenAmount = metadata?.disabledArticlesCount;

  const [activeItemIndex, setActiveItemIndex] = useState(
    defaultActiveItemIndex
  );

  const navigationData = {
    ['All']: {
      copy: 'EP-ARTICLES-MODULE-FILTER-ALL',
      amount: allAmount,
      value: undefined,
    },
    ['Published']: {
      copy: 'EP-ARTICLES-MODULE-FILTER-PUBLISHED',
      amount: publishedAmount,
      value: ContentArticleStatus.Published,
    },
    ['Scheduled']: {
      copy: 'EP-ARTICLES-MODULE-FILTER-SCHEDULED',
      amount: scheduledAmount,
      value: ContentArticleStatus.Scheduled,
    },
    ['Draft']: {
      copy: 'EP-ARTICLES-MODULE-FILTER-DRAFTS',
      amount: draftsAmount,
      value: ContentArticleStatus.Draft,
    },
    ['Disabled']: {
      copy: 'EP-ARTICLES-MODULE-FILTER-HIDDEN',
      amount: hiddenAmount,
      value: ContentArticleStatus.Disabled,
    },
  };

  const handleOnClicked = (
    index: number,
    value: ContentArticleStatus | undefined
  ) => {
    setActiveItemIndex(index);
    updateFilter(value);
  };

  const contentSwitcherData = Object.values(navigationData).map(
    ({ copy, amount, value }, index) => ({
      copy: `${$t({ id: copy })} ${amount !== undefined ? `(${amount})` : ''}`,
      ['data-testid']: copy,
      onClick: () => handleOnClicked(index, value),
    })
  );

  return (
    <ContentSwitcher
      className={className}
      data={contentSwitcherData}
      activeItemIndex={activeItemIndex}
    />
  );
};
